<div class="summary card bb-panel">
    <div>
        <!-- <img src="{{selectedService?.image?.url}}" alt="service image" class="service-image" /> -->
    </div>
    <div class="heading-section">
        <h5 tabindex="0" aria-label="your booking summary">Your booking</h5>
    </div>
    <div class="summary-content">
        <p tabindex="0" class="summary-content-header">{{selectedService?.name}}</p>
        <p tabindex="0" class="pb-3" *ngIf="selectedService">{{selectedService.booking_time_step}} minutes</p>
        <!-- <p tabindex="0" *ngIf="selectedService?.price > 0" class="summary-content-header"> £{{selectedService?.price /100}}</p> -->
        <p tabindex="0" *ngIf="selectedSlot" class="summary-content-header pb-0">{{selectedSlot?.datetime | date: 'EEEE d MMMM yyyy'}}</p>
        <p tabindex="0" *ngIf="selectedSlot" class="pb-3">{{selectedSlot?.datetime | date: 'HH:mm'}} - {{endSlot | date: 'HH:mm'}}</p>

        <p tabindex="0" aria-label="selected location" class="summary-content-header pb-0">{{selectedLocation?.name}}</p>
        <p tabindex="0">{{address?.address.address1}}</p>
        <p tabindex="0">{{address?.address.address2}}</p>
        <p tabindex="0">{{address?.address.address4}}</p>
        <p tabindex="0">{{address?.address.address5}}</p>
        <p tabindex="0">{{address?.address.postcode}}</p>
        <p tabindex="0" *ngIf="address?.address.homephone">0{{address?.address.homephone}}</p>
       
    </div>
</div>